import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, CaptureThumb, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { InfinityIcon, Clock } from "@/lib/icons";

export default function Continue() {
  const [tasks, setTasks] = useState([]);
  const [archived, setArchived] = useState([]);
  const [recent, setRecent] = useState([]);
  const [newTask, setNewTask] = useState("");

  const load = () => {
    api.get("/tasks").then((r) => setTasks(r.data.tasks)).catch(() => {});
    api.get("/captures", { params: { review_state: "archived" } }).then((r) => setArchived(r.data.captures)).catch(() => {});
    api.get("/captures", { params: { review_state: "reviewed", sort: "recent" } }).then((r) => setRecent(r.data.captures.slice(0, 8))).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const addTask = async () => { if (!newTask.trim()) return; await api.post("/tasks", { title: newTask }); setNewTask(""); load(); };
  const toggle = async (t) => { await api.patch(`/tasks/${t.id}`, { done: !t.done }); load(); };

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <PageHeader eyebrow="Continue" color="#14B8A6" title="Continue"
        subtitle="Keep the story going. Follow-ups, resume work, and archive retrieval." />

      <section>
        <h2 className="font-display text-lg font-semibold text-white mb-3">Follow-up tasks</h2>
        <div className="dl-card p-4 space-y-3">
          <div className="flex gap-2">
            <Input value={newTask} onChange={(e) => setNewTask(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addTask()} placeholder="Add a follow-up…" className="bg-black/20" data-testid="new-task-input" />
            <Button onClick={addTask} style={{ background: "#14B8A6" }} data-testid="add-task-btn">Add</Button>
          </div>
          {tasks.length === 0 ? <p className="text-sm text-slate-500">No follow-ups. Add one above.</p> :
            tasks.map((t) => (
              <label key={t.id} className="flex items-center gap-3 text-sm" data-testid={`task-${t.id}`}>
                <Checkbox checked={t.done} onCheckedChange={() => toggle(t)} />
                <span className={t.done ? "line-through text-slate-500" : "text-white"}>{t.title}</span>
                {t.due_date && <span className="text-[11px] text-slate-500 ml-auto">due {new Date(t.due_date).toLocaleDateString()}</span>}
              </label>
            ))}
        </div>
      </section>

      <section>
        <h2 className="font-display text-lg font-semibold text-white mb-3">Resume work</h2>
        {recent.length === 0 ? <p className="text-sm text-slate-500">Nothing reviewed yet.</p> : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">{recent.map((c) => <CaptureThumb key={c.id} cap={c} />)}</div>
        )}
      </section>

      <section>
        <h2 className="font-display text-lg font-semibold text-white mb-3">Archive</h2>
        {archived.length === 0 ? <EmptyState icon={InfinityIcon} title="Archive is empty" hint="Archived captures stay retrievable here." /> : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">{archived.map((c) => <CaptureThumb key={c.id} cap={c} />)}</div>
        )}
      </section>
    </div>
  );
}
